// Used in avenue-asset-list.component.html

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import { MatRadioButton } from "@angular/material/radio";

// Services/Types/Helpers
import { PPUser as User } from "cli-types";

// RXJS/Store
import { PerformMedia } from "@carnegie-learning/cure-types";
import { AvenueService } from "@carnegie-learning/data-access-angular-passport";
import { Observable } from "rxjs";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "avenue-asset-item",
    templateUrl: "./avenue-asset-item.component.html",
    styleUrls: [
        "./avenue-asset-item.component.scss",
        "../../../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class AvenueAssetItemComponent implements OnInit {
    mediaUrl$: Observable<string>;
    extensionsImg: string[] = ["jpg", "jpeg", "png"];
    extensionsVideo: string[] = ["mp4", "webm", "mov", "m4v"];
    isMediaUrlLoaded = false;

    @Input() asset!: PerformMedia;
    @Input() selectedAsset?: PerformMedia;
    @Input() profile?: User;

    @Output() editAssetEvent = new EventEmitter<PerformMedia>();
    @Output() deleteAssetEvent = new EventEmitter<PerformMedia>();
    @Output() selectAsset = new EventEmitter<PerformMedia>();

    constructor(private avenueTasksService: AvenueService) {}

    ngOnInit() {
        if (!this.asset?.performType) {
            this.asset.performType = this.typeCzech(this.asset, "image")
                ? 1
                : 0; // video = 0, image = 1
        }
        this.mediaUrl$ = this.avenueTasksService.getMediaUrl(this.asset);
    }

    canBeEdited(asset?: PerformMedia) {
        if (!asset) {
            return false;
        }
        return (
            asset.publishedBy === this.profile?.userGUID ||
            this.profile?.roleLevel === 1
        );
    }

    editAsset(asset: PerformMedia) {
        this.editAssetEvent.emit(asset);
    }

    deleteAsset(asset: PerformMedia) {
        this.deleteAssetEvent.emit(asset);
    }

    playVideo(event: MouseEvent) {
        if (event.target && event.target instanceof HTMLVideoElement) {
            event.target.play();
        }
    }

    pauseVideo(event: MouseEvent) {
        if (event.target && event.target instanceof HTMLVideoElement) {
            event.target.pause();
        }
    }

    onSelectAsset(event: MatRadioButton, asset: PerformMedia | undefined) {
        this.selectAsset.emit(asset);
    }

    typeCzech(asset: PerformMedia, type: string): boolean {
        const testArray =
            type === "video" ? this.extensionsVideo : this.extensionsImg;
        return asset && testArray.includes(asset?.fileExt);
    }

    isAssetSelected(asset?: PerformMedia) {
        if (!this.selectedAsset || !asset) {
            return false;
        }
        return this.selectedAsset.assetId === asset.assetId;
    }
}
